module.exports = __webpack_public_path__ + "media/images/check-212e61b4.svg";